export default __webpack_public_path__ + "static/3-5e4a99d64dbf188cbd9ee5e84a4a337c.png";